import * as React from "react";
import { useFormContext } from "react-hook-form";

import {
  TextInput,
  TextInputGroup,
  TextInputGroupProps,
  TextInputLabel,
  TextInputProps,
} from "@/components/TextInput";
import { ErrorHandler } from "@/containers/fields/ErrorHandler";

interface TextInputFieldProps extends TextInputProps {
  label?: string;
  name: string;
  required?: boolean;
  hint?: React.ReactNode;
  validate?: Record<string, (v: any) => boolean>;
  startAdornment?: TextInputGroupProps["startAdornment"];
  startAdornmentSize?: TextInputGroupProps["startAdornmentSize"];
  endAdornment?: TextInputGroupProps["endAdornment"];
  endAdornmentSize?: TextInputGroupProps["endAdornmentSize"];
}

export const TextInputField = (props: TextInputFieldProps) => {
  const {
    label,
    name,
    validate,
    required = false,
    scale = "md",
    hint,
    startAdornment,
    startAdornmentSize,
    endAdornment,
    endAdornmentSize,
    className,
    ...rest
  } = props;
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <div className={className}>
      {label && (
        <TextInputLabel required={required} scale={scale}>
          {label}
        </TextInputLabel>
      )}
      <TextInputGroup
        scale={scale}
        startAdornment={startAdornment}
        startAdornmentSize={startAdornmentSize}
        endAdornment={endAdornment}
        endAdornmentSize={endAdornmentSize}
      >
        <TextInput
          scale={scale}
          aria-invalid={errors[name] ? "true" : "false"}
          {...rest}
          {...register(name, {
            required: { value: required, message: "This field is required" },
            validate,
          })}
        />
      </TextInputGroup>
      {!errors[name] && hint && (
        <div className="mt-2 text-sm text-grey-on">{hint}</div>
      )}
      <ErrorHandler name={name} errors={errors} />
    </div>
  );
};
